import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { EditableTitle } from '@/shared/ui';
import { UserGroupFromValues } from './types';

type Props = {
  isCreate: boolean;
  onUpdateName?: (name: string) => void;
  disabled?: boolean;
};

export const EditableGroupTitle: FC<Props> = (props) => {
  const { isCreate, onUpdateName, disabled } = props;

  const { t } = useTranslation(['users']);

  const { setValue } = useFormContext<UserGroupFromValues>();
  const nameValue = useWatch({ name: 'name' });

  const handleSave = (newValue: string) => {
    setValue('name', newValue);

    if (isCreate) {
      return;
    }

    if (newValue && newValue !== nameValue && onUpdateName) {
      onUpdateName(newValue);
    }
  };

  return (
    <EditableTitle
      value={nameValue ?? ''}
      placeholder={isCreate ? t('users:newGroup') : ''}
      disabled={disabled}
      onSave={handleSave}
      fixedInputWidth
    />
  );
};
